import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import RequestFindDetail from "../detail/detailFindPage";
import SaleFactorsSearch from "../supplierSettelments/saleFactorsSearch";
import LoanFindPage from "./findPage/loanFindPage";
import LoanFindReqPage from "./findPage/loanFindReqPage";
import ChequeReport from "./findPage/ChequeReport";

export default function SearchConfigPage() {
  const active = localStorage.getItem("setActivePage");
  return (
    <Switch>
      {
        /* Redirect from eCommerce root URL to /customers */
        <Redirect exact={true} from="/Search" to={`/Search/${active}`} />
      }

      <ContentRoute
        path="/Search/SupplierSearch"
        component={LoanFindPage}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Search/CustomerSearch"
        component={LoanFindReqPage}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Search/:activePage1/request-find-detail"
        component={RequestFindDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Search/SaleFactorsSearch"
        component={SaleFactorsSearch}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/Search/ChequeReport"
        component={ChequeReport}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
